module.exports = __webpack_public_path__ + "img/button_image14.6be1330a.jpg";